import { apiRequest } from "./client";

function queryString(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const query = search.toString();
  return query ? `?${query}` : "";
}

function base(projectId) {
  return `/projects/${projectId}/erp`;
}

export const erpApi = {
  bootstrap(projectId) {
    return apiRequest(`${base(projectId)}/bootstrap`);
  },

  overview(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/stats/overview${queryString(params)}`);
  },

  listAccounts(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/accounts${queryString(params)}`);
  },

  createAccount(projectId, payload) {
    return apiRequest(`${base(projectId)}/accounts`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateAccount(projectId, accountId, payload) {
    return apiRequest(`${base(projectId)}/accounts/${accountId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  listTaxProfiles(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/tax-profiles${queryString(params)}`);
  },

  createTaxProfile(projectId, payload) {
    return apiRequest(`${base(projectId)}/tax-profiles`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateTaxProfile(projectId, taxProfileId, payload) {
    return apiRequest(`${base(projectId)}/tax-profiles/${taxProfileId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  listMovements(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/movements${queryString(params)}`);
  },

  getMovement(projectId, movementId) {
    return apiRequest(`${base(projectId)}/movements/${movementId}`);
  },

  createMovement(projectId, payload) {
    return apiRequest(`${base(projectId)}/movements`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  createConfirmedMovement(projectId, payload) {
    return apiRequest(`${base(projectId)}/movements/confirm-now`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateMovement(projectId, movementId, payload) {
    return apiRequest(`${base(projectId)}/movements/${movementId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  confirmMovement(projectId, movementId) {
    return apiRequest(`${base(projectId)}/movements/${movementId}/confirm`, {
      method: "POST",
      body: JSON.stringify({}),
    });
  },

  voidMovement(projectId, movementId, reason) {
    return apiRequest(`${base(projectId)}/movements/${movementId}/void`, {
      method: "POST",
      body: JSON.stringify({ reason }),
    });
  },

  listLedger(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/ledger${queryString(params)}`);
  },

  ledgerBalances(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/ledger/balances${queryString(params)}`);
  },

  listTransactions(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/transactions${queryString(params)}`);
  },

  listStockMovements(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/stock-movements${queryString(params)}`);
  },

  listCashRegisters(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/cash/registers${queryString(params)}`);
  },

  createCashRegister(projectId, payload) {
    return apiRequest(`${base(projectId)}/cash/registers`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateCashRegister(projectId, registerId, payload) {
    return apiRequest(`${base(projectId)}/cash/registers/${registerId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  openCashRegister(projectId, registerId, payload) {
    return apiRequest(`${base(projectId)}/cash/registers/${registerId}/open`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  listCashSessions(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/cash/sessions${queryString(params)}`);
  },

  closeCashSession(projectId, cashSessionId, payload) {
    return apiRequest(`${base(projectId)}/cash/sessions/${cashSessionId}/close`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  reviewCashSession(projectId, cashSessionId, payload) {
    return apiRequest(`${base(projectId)}/cash/sessions/${cashSessionId}/review`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  listCashMovements(projectId, params = {}) {
    return apiRequest(`${base(projectId)}/cash/movements${queryString(params)}`);
  },

  recordCashOperation(projectId, payload) {
    return apiRequest(`${base(projectId)}/cash/operations`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
};
